// extracted by mini-css-extract-plugin
module.exports = {"cell":"NumericCell_cell__1mRmC"};